<template>
  <div class="box">
    <div v-if="amCloudResource.total!=0" class="list">
      <div v-for="(item,index) of amCloudResource.list" :key="index" class="item">
        <div @click='goDetail(item.id,item.type)' class="item-left">
          <img class="cover-img" :src="imgUrl(item.fileType)" alt="">
          <div class="content">
            <span class="title">{{item.name}}</span>
            <div class="message">
              <div v-if="item.fileSize||item.fileSize==0" class="message-item">
                <img width="16px" height="16px" src="~@/assets/img/resourceCenter/daxiao.png" alt="">
                <span>大小: {{fileSize(item)}}</span>
              </div>
              <div v-if="item.browseNum||item.browseNum==0" class="message-item">
                <img width="16px" height="16px" src="~@/assets/img/resourceCenter/liulan.png" alt="">
                <span>浏览: {{item.browseNum}}</span>
              </div>
              <div v-if="item.downNum||item.downNum==0" class="message-item">
                <img width="16px" height="16px" src="~@/assets/img/resourceCenter/xiazaishu.png" alt="">
                <span>下载: {{item.downNum}}</span>
              </div>

              <div v-if="item.likeNum" class="message-item">
                <img width="16px" height="16px" src="~@/assets/img/resourceCenter/haoping.png" alt="">
                <span>好评: {{item.likeNum}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="citem-right">
          <div class="download">

            <el-dropdown @command='handleCommand($event,item)'>
              <span @click="monofile(item.fileIdList[0],item)" class="el-dropdown-link">
                <el-image style="width: 24px;" :src="url"></el-image>
                <div>下载</div>
              </span>

              <el-dropdown-menu v-if="item.fileIdList.length!=1" slot="dropdown">
                <el-dropdown-item :command='value' v-for="(value,i) of item.fileIdList" :key="item.id+value">
                  {{item.name}}({{i+1}})
                </el-dropdown-item>
              </el-dropdown-menu>

              <!-- 单文件时 -->
              <el-dropdown-menu v-if="item.fileIdList.length==1"
                :style="{padding:(item.fileIdList.length==1?0:'10px 0'),border:(item.fileIdList.length==1?0:'1px solid #EBEEF5;')}"
                slot="dropdown">
              </el-dropdown-menu>

            </el-dropdown>

          </div>

        </div>
      </div>

    </div>
    <NoData v-show="!loading" v-else />
  </div>
</template>

<script>
import { getPersignedUrl } from "@/network/resourceRequest/api";
import utils from "@/util/index";
import NoData from "@/components/common/NoData";
export default {
  name: "ResourceList",
  components: {
    NoData,
  },
  props: {
    amCloudResource: {},
    loading: {},
  },
  data() {
    return {
      url: require("@/assets/img/resourceCenter/xiazai.png"),
    };
  },

  methods: {
    //多文件下载--------------------------------------------
    handleCommand(fileId, item) {
      if (!this.$store.state.isLogin) return utils.tipsLogin();
      let data = {
        id: fileId,
        fileResourceId: item.id,
        filename: `${item.name}`,
      };
      // 发送真正的网络请求
      getPersignedUrl(data).then((res) => {
        var link = document.createElement("a");
        //设置下载的文件名
        link.download = `${item.name}.${
          res.data.data.split("?")[0].split(".").reverse()[0]
        }`;
        link.style.display = "none";
        //设置下载路径
        link.href = res.data.data;
        //触发点击
        document.body.appendChild(link);
        link.click();
        //移除节点
        document.body.removeChild(link);
      });
    },

    //单文件下载
    monofile(fileId, item) {
      if (!this.$store.state.isLogin) return utils.tipsLogin();
      if (item.fileIdList.length == 1) {
        let data = {
          id: fileId,
          fileResourceId: item.id,
          filename: `${item.name}`,
        };
        // 发送真正的网络请求
        getPersignedUrl(data).then((res) => {
          var link = document.createElement("a");
          //设置下载的文件名
          link.download = `${item.name}.${
            res.data.data.split("?")[0].split(".").reverse()[0]
          }`;
          link.style.display = "none";
          //设置下载路径
          link.href = res.data.data;
          //触发点击
          document.body.appendChild(link);
          link.click();
          //移除节点
          document.body.removeChild(link);
        });
      }
    },

    //跳转详情--------------------------------------------
    goDetail(id,typeState) {
      // console.log(id)
      this.$router.push({
        path: "/resource-detail",
        query: { id,typeState },
      });
    },

    //文件大小
    fileSize(item) {
      let KB = parseInt(item.fileSize / 1024);
      let MB = parseInt(item.fileSize / 1024 / 1024);
      let G = parseInt(item.fileSize / 1024 / 1024 / 1024);
      if (KB < 1024) {
        return KB + "KB";
      } else if (MB < 1024) {
        return MB + "MB";
      } else if (G < 1024) {
        return G + "G";
      }
    },
  },

  computed: {
    //获取图片默认封面--------------------------------------------
    imgUrl() {
      return function (type) {
        let str = type ? type.toLowerCase() : "";
        switch (str) {
          case "pdf":
            return require("@/assets/img/resourceCenter/pdf.png");
            break;
          case "ppt":
          case "pptx":
            return require("@/assets/img/resourceCenter/ppt.png");
            break;
          case "doc":
          case "docx":
            return require("@/assets/img/resourceCenter/word.png");
            break;
          case "xls":
          case "xlsx":
            return require("@/assets/img/resourceCenter/excel.png");
            break;
          //动画--------------------------------------------
          case "swf":
            return require("@/assets/img/resourceCenter/swf.png");
            break;
          //视频--------------------------------------------
          case "mp4":
          case "mpeg4":
            return require("@/assets/img/resourceCenter/shipin.png");
            break;
          //音频--------------------------------------------
          case "mp3":
          case "mpeg3":
            return require("@/assets/img/resourceCenter/yinpin.png");
            break;
          //图片--------------------------------------------
          case "jpg":
          case "jpeg":
          case "png":
          case "gif":
          case "bmp":
            return require("@/assets/img/resourceCenter/tupian.png");
            break;
          default:
            return require("@/assets/img/resourceCenter/weizhi.png");
            break;
        }
      };
    },
  },
};
</script>

<style lang='less' scoped>
.box {
  width: 100%;
  height: 100%;

  .list {
    width: 100%;
    height: 100%;

    .item:hover {
      box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
      transform: translateY(1px);
    }

    .item {
      padding-left: 20px;

      height: 108px;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      display: flex;
      justify-content: space-between;
      align-items: center;

      .item-left {
        flex: 1;
        display: flex;

        .cover-img {
          display: block;
          width: 68px;
          height: 68px;
        }

        .content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 10px;

          .title {
            height: 12px;
            font-size: 13px;
            font-weight: 400;
            color: rgba(68, 68, 68, 1);
            margin-bottom: 21px;
          }

          .message {
            display: flex;

            .message-item {
              display: flex;
              align-items: center;
              font-size: 12px;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              margin-right: 20px;

              img {
                margin-right: 4px;
              }
            }
          }
        }
      }

      .citem-right {
        display: flex;
        font-size: 12px;
        font-weight: 400;
        color: rgba(68, 68, 68, 1);

        .download {
          cursor: pointer;
          margin-right: 40px;
        }

        .push {
          cursor: pointer;
          margin-right: 20px;
        }
      }
    }
  }
}

//下载下拉框样式
.el-dropdown-menu {
  /deep/.el-dropdown-menu__item:hover {
    background-color: #fff;
    color: #24ba58;
  }
}
</style>